import { useState } from 'react';
import qs from 'qs';
import { sortOptionsByType } from '@react/data/sortOptions';

const queryParams = qs.parse(window.location.search.slice(1));

export const getSortOption = (searchTypeIndex, sortQueryParam) => {
    const sortOptions = sortOptionsByType[searchTypeIndex];

    if (!sortOptions) {
        return null;
    }

    const sortByFromUrl = sortOptions.find(option => option.queryParam === sortQueryParam);
    return sortByFromUrl || sortOptions.find(option => option.default);
};

const useSortBy = initalSearchType => {
    const [sortBy, setSortBy] = useState(getSortOption(initalSearchType.index, queryParams.sort));

    const getDefaultSortForType = searchTypeIndex => {
        const sortOptions = sortOptionsByType[searchTypeIndex];
        return sortOptions.find(option => option.default);
    };

    const setSortByDefault = searchTypeIndex => {
        const sortByDefault = getDefaultSortForType(searchTypeIndex);
        setSortBy(sortByDefault);
    };

    return { sortBy, setSortBy, setSortByDefault };
};

export default useSortBy;
